
    // this file was auto generated by python script
    import FileText from './FileText';
    export default FileText;
    